import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-menu',
  imports: [CommonModule, RouterModule, MenuItemComponent],
  template: `
    <aside
      class="sidebar z-0 flex flex-col h-full"
      [class.collapsed]="collapsed()"
    >
      <div class="sidebar-content">
        <ul class="menu-list">
          @for (menuGroup of menuItems; track menuGroup.label) {
            <li class="menu-group">
              @if (!collapsed()) {
                <div class="group-label">{{ menuGroup.label }}</div>
              }
              @if (menuGroup.items && menuGroup.items.length > 0) {
                <ul class="menu-items">
                  @for (item of menuGroup.items; track item.label) {
                    <app-menu-item
                      [item]="item"
                      [collapsed]="collapsed()"
                    ></app-menu-item>
                  }
                </ul>
              }
            </li>
          }
        </ul>
      </div>
      <div class="mt-auto mb-5 text-center">
        Bemine by
        <a
          target="_blank"
          rel="noopener noreferrer"
          class="text-primary font-bold hover:underline"
          >LCS Consultoria</a
        >
      </div>
    </aside>
  `,
})
export class MenuComponent {
  private translate = inject(TranslateService);

  collapsed = signal<boolean>(false);

  menuItems: MenuItem[] = [];

  async ngOnInit() {
    this.loadMenuItems();
  }

  toggleCollapse(): void {
    this.collapsed.update((value) => !value);
  }

  private async loadMenuItems() {
    this.menuItems = [
      {
        items: [
          {
            label: 'Dashboard',
            icon: 'ph-duotone ph-house text-lg',
            routerLink: ['/dashboard'],
          },
          {
            label: 'Gestão de Produtos',
            items: [
              {
                label: 'Produtos',
                icon: 'ph-duotone ph-barcode text-lg',
                routerLink: ['/products'],
              },
              {
                label: 'Marcas',
                icon: 'ph-duotone ph-apple-logo text-lg',
                routerLink: ['/brands'],
              },
              {
                label: 'Categorias',
                icon: 'ph-duotone ph-list-heart text-lg',
                routerLink: ['/categories'],
              },
              {
                label: 'Modelos',
                icon: 'ph-duotone ph-squares-four text-lg',
                routerLink: ['/models'],
              },
              {
                label: 'Versões',
                icon: 'ph-duotone ph-approximate-equals text-lg',
                routerLink: ['/model-versions'],
              },
              {
                label: 'Atributos',
                icon: 'ph-duotone ph-circles-four text-lg',
                routerLink: ['/variation-attributes'],
              },
              {
                label: 'Valores de Atributos',
                icon: 'ph-duotone ph-rows-plus-top text-lg',
                routerLink: ['/variation-attribute-values'],
              },
            ],
          },
          {
            label: 'Gestão de Ofertas',
            items: [
              {
                label: 'Ofertas',
                icon: 'ph-duotone ph-seal-percent text-lg',
                routerLink: ['/offers'],
              },
              {
                label: 'Frequências',
                icon: 'ph-duotone ph-repeat text-lg',
                routerLink: ['/payment-frequencies'],
              },
              {
                label: 'Multas',
                icon: 'ph-duotone ph-receipt text-lg',
                routerLink: ['/late-fee-policies'],
              },
            ],
          },
          {
            label: 'Gestão de Pedidos',
            items: [
              {
                label: 'Lista de Pedidos',
                icon: 'ph-duotone ph-star text-lg',
                routerLink: ['/orders'],
              },
              {
                label: 'Avaliações',
                icon: 'ph-duotone ph-gavel text-lg',
                routerLink: ['/assessments'],
              },
              {
                label: 'Regras',
                icon: 'ph-duotone ph-list-star text-lg',
                routerLink: ['/assessment-rules'],
              },
              {
                label: 'Identificadores do Produto',
                icon: 'ph-duotone ph-squares-four text-lg',
                routerLink: ['/product-identifier-types'],
              },
              {
                label: 'Transportadoras',
                icon: 'ph-duotone ph-squares-four text-lg',
                routerLink: ['/carriers'],
              },
              {
                label: 'Modelos de Contratos',
                icon: 'ph-duotone ph-file-doc text-lg',
                routerLink: ['/contract-templates'],
              },
            ],
          },
          {
            label: 'Clientes',
            icon: 'ph-duotone ph-users-three text-lg',
            routerLink: ['/customers'],
          },
          {
            label: 'Colaboradores',
            icon: 'ph-duotone ph-user-list text-lg',
            routerLink: ['/employees'],
          },
          {
            label: 'Gestão do Site',
            items: [
              {
                label: 'Áreas de Exibição',
                icon: 'ph-duotone ph-corners-out text-lg',
                routerLink: ['/display-areas'],
              },
              {
                label: 'Parâmetros',
                icon: 'ph-duotone ph-sliders text-lg',
                routerLink: ['/parameters'],
              },
              {
                label: 'Textos do Site',
                icon: 'ph-duotone ph-text-t text-lg',
                routerLink: ['/text-contents'],
              },
            ],
          },
          {
            label: 'Gestão Fiscal',
            items: [
              {
                label: 'Taxas',
                icon: 'ph-duotone ph-receipt text-lg',
                routerLink: ['/tax-rates'],
              },
            ],
          },
        ],
      },
    ];
  }
}
